<template>
  <BackofficeLayout :title="title" :loading="loading" :breadcrumb="breadcrumb">
    <div class="wrapper">
      <div class="main">
        <div class="statistic-panel">
          <div class="statistic statistic--navy">
            <v-icon class="statistic-icon">mdi-school</v-icon>
            <div>
              <p class="statistic-caption">
                {{ $t("message.common.required_amount") }}
              </p>
              <p class="statistic-value">
                {{ summary.total_student }}
              </p>
            </div>
          </div>
          <div class="statistic statistic--brown">
            <v-icon class="statistic-icon">mdi-account-multiple</v-icon>
            <div>
              <p class="statistic-caption">
                {{ this.$t("message.registration_form.applicants") }}
              </p>
              <p class="statistic-value">
                {{ summary.total_register }}
              </p>
            </div>
          </div>
          <div class="statistic statistic--yellow">
            <v-icon class="statistic-icon">mdi-file</v-icon>
            <div>
              <p class="statistic-caption">
                {{ $t("message.registration_form.qualified") }}
              </p>
              <p class="statistic-value">
                {{ summary.total_authorize }}
              </p>
            </div>
          </div>
          <div class="statistic statistic--orange">
            <v-icon class="statistic-icon">mdi-check-circle</v-icon>
            <div>
              <p class="statistic-caption">
                {{ $t("message.registration_form.confirmed") }}
              </p>
              <p class="statistic-value">
                {{ summary.total_successful_confirmation }}
              </p>
            </div>
          </div>
          <div class="statistic statistic--gold">
            <v-icon class="statistic-icon">mdi-shield-check</v-icon>
            <div>
              <p class="statistic-caption">
                {{ $t("message.registration_form.initiation_complete") }}
              </p>
              <p class="statistic-value">
                {{ summary.total_enrollment }}
              </p>
            </div>
          </div>
        </div>
        <v-sheet
          class="px-5 py-5 radius-10px"
          color="white"
          rounded
          elevation="1"
        >
          <div class="form-description-wrapper">
            <v-icon class="icon--blue">mdi-alert-circle</v-icon>
            <p class="form-title">{{ $t("message.common.suggestion") }}</p>
          </div>
          <div class="form-description advice-box">
            <ul style="list-style: auto">
              <li>
                {{ $t("message.registration_form.suggestion_1_start") }}
                <v-icon>mdi-pencil</v-icon>
                {{ $t("message.registration_form.suggestion_1_end") }}
              </li>
              <li>
                {{ $t("message.registration_form.suggestion_2") }}
                <ul style="list-style: disc">
                  <li>
                    {{ $t("message.registration_form.suggestion_2_1") }}
                    <br />{{ $t("message.registration_form.suggestion_2_2") }}
                    <ul style="list-style: disc">
                      <li>
                        {{ $t("message.registration_form.suggestion_2_2_1") }}
                      </li>
                      <li>
                        {{ $t("message.registration_form.suggestion_2_2_2") }}
                      </li>
                    </ul>
                  </li>
                  <li>{{ $t("message.registration_form.suggestion_2_3") }}</li>
                  <li>{{ $t("message.registration_form.suggestion_2_4") }}</li>
                  <li>
                    {{ $t("message.registration_form.suggestion_2_5") }}
                  </li>
                  <li>
                    {{ $t("message.registration_form.suggestion_2_6") }}
                  </li>
                  <li>
                    {{ $t("message.registration_form.suggestion_2_7") }}
                  </li>
                  <li>
                    {{ $t("message.registration_form.suggestion_2_8") }}
                  </li>
                  <li>
                    {{ $t("message.registration_form.suggestion_2_9")
                    }}<br /><span style="color: red">*</span>
                    {{
                      $t(
                        "message.registration_form.suggestion_status_description_remark"
                      )
                    }}
                  </li>
                </ul>
              </li>
              <li>
                {{ $t("message.registration_form.suggestion_3") }}
                <router-link
                  class="link link--primary"
                  to="/registration/qualified"
                  >{{
                    $t("message.registration_form.list_of_qualified")
                  }}</router-link
                >
              </li>
            </ul>
          </div>
        </v-sheet>
        <v-sheet color="white" rounded elevation="1" class="radius-10px">
          <v-sheet class="px-5 py-5 radius-10px" elevation="0">
            <v-row class="flex-column row-column" no-gutters>
              <v-col>
                <v-row class="row-form" no-gutters>
                  <v-col>
                    <p class="form-title">
                      {{ $t("message.registration_form.list_of_applicants") }}
                    </p>
                    <div class="form-description form-description--small">
                      <p>
                        {{ $t("message.adminPage.listApp_content") }}
                      </p>
                      <ul>
                        <li>
                          {{ $t("message.adminPage.listApp_content2") }}
                        </li>
                        <li>
                          {{ $t("message.adminPage.listApp_content3") }}
                        </li>
                      </ul>
                    </div>
                  </v-col>

                  <v-col md="auto" class="align-end">
                      <div class="text-end">
                          <v-menu transition="slide-y-transition">
                              <template v-slot:activator="{ on, attrs }">
                                  <v-btn
                                      color="primary"
                                      rounded
                                      width="200"
                                      v-bind="attrs"
                                      v-on="on">
                                      {{ $t("message.registration_form.download_applicants") }}
                                      <v-icon class="icon--white" size="24">mdi-chevron-down</v-icon>
                                  </v-btn>
                              </template>
                              <v-list class="mt-12">
                                  <v-list-item
                                      v-for="(item, index) in downloadList"
                                      :key="index" link>
                                      <v-list-item-title
                                          @click="[1,3].includes(item.value) ? downloadExcel(item.value) : downloadPdf(item.value)">
                                          {{ item.text }}
                                      </v-list-item-title>
                                  </v-list-item>
                              </v-list>
                          </v-menu>
                      </div>
                  </v-col>

                  <!-- <v-col md="auto" class="align-end">
                    <v-btn
                      color="primary"
                      rounded
                      width="200"
                      @click="downloadExcelCandidate()"
                    >
                      <v-icon left class="icon--white">mdi-download</v-icon>
                      {{ $t("message.registration_form.list_of_applicants") }}
                    </v-btn>
                  </v-col> -->
                </v-row>
              </v-col>
              <v-col>
                <div class="form-row form-row-gap--xl">
                  <div class="form-row form-row-gap--sm mb-0">
                    <v-text-field
                      v-model="keyword"
                      outlined
                      :placeholder="
                        $t('message.registration_form.search_by_applicants_name')
                      "
                      prepend-inner-icon="mdi-magnify"
                      required
                      dense
                      hide-details
                      style="width: 380px"
                    ></v-text-field>
                    <v-btn
                      v-if="keyword.length > 0"
                      color="primary"
                      outlined
                      width="90"
                      @click="search"
                    >
                      {{ $t("message.common.search") }}
                    </v-btn>
                    <v-btn
                      v-else
                      color="gray"
                      outlined
                      width="90"
                      @click="search"
                    >
                      {{ $t("message.common.search") }}
                    </v-btn>
                  </div>
                  <v-select
                    v-model="selectedRegistrationStatus"
                    @change="changeRegistrationStatus"
                    outlined
                    :items="registrationStatusOption"
                    :item-text="`label_${$i18n.locale}`"
                    item-value="value"
                    prepend-inner-icon="mdi-filter-variant"
                    dense
                    hide-details
                    style="width: 240px"
                  ></v-select>
                  <v-select
                    v-model="selectedResultType"
                    @change="changeResultType"
                    outlined
                    :items="resultTypeOption"
                    :item-text="`label_${$i18n.locale}`"
                    item-value="value"
                    prepend-inner-icon="mdi-filter-variant"
                    dense
                    hide-details
                    style="width: 240px"
                  ></v-select>
                </div>
              </v-col>
            </v-row>
          </v-sheet>

          <v-data-table
            class="custom-data-table custom-data-table--color"
            @update:items-per-page="handleChangePageSize"
            @update:page="handleChangePage"
            :page.sync="page"
            :headers="headers"
            :items="student"
            :server-items-length="total"
            :items-per-page="pageSize"
            :footer-props="{
              'page-text': `${page} ${$t(
                'message.common.pagination.of'
              )} ${pages}`,
              'items-per-page-text': `${$t(
                'message.common.pagination.row_per_page'
              )}:`,
              'items-per-page-options': pageSizeOption,
            }"
            hide-default-header
            :hide-default-footer="student <= 0"
          >
            <template v-slot:header="{ props: { headers } }">
              <thead>
                <tr>
                  <th
                    v-for="item in headers"
                    :key="item.value"
                    class="column"
                    :style="{ width: `${item.width}` }"
                  >
                    <div
                      v-if="item.sortable"
                      class="custom-table-header"
                      @click="handleChangeSort(item.sort)"
                    >
                      {{ item.text }}
                      <template v-if="item.sort === sort">
                        <v-icon v-if="sortDirection === 'desc'" small
                          >mdi-chevron-up</v-icon
                        >
                        <v-icon v-else small>mdi-chevron-down</v-icon>
                      </template>
                      <template v-else>
                        <v-icon small>mdi-unfold-more-horizontal</v-icon>
                      </template>
                    </div>
                  </th>
                </tr>
              </thead>
            </template>
            <template v-slot:[`item.national_id`]="{ item }">
              {{ item.student_detail.national_id }}
            </template>
            <template v-slot:[`item.name`]="{ item }">
              {{ item.student_detail.prefix_id[`text_${$i18n.locale}`]
              }}{{ item.student_detail[`name_${$i18n.locale}`] }}
              {{ item.student_detail[`surname_${$i18n.locale}`] }}
            </template>
            <template v-slot:[`item.result_type`]="{ item }">
              <span style="color: red" v-if="item.result_type === 'FAILED'">
                {{
                  studentTypeMapping[item.result_type]?.[
                    `text_${$i18n.locale}`
                  ] ?? "-"
                }}
              </span>
              <span v-else>
                {{
                  studentTypeMapping[item.result_type]?.[
                    `text_${$i18n.locale}`
                  ] ?? "-"
                }}
              </span>
            </template>
            <template v-slot:[`item.type`]="{ item }">
              {{
                studentResultTypeMapping[item.result_type]?.[
                  `text_${$i18n.locale}`
                ] ?? "-"
              }}
              {{
                studentResultTypeMapping[item.result_type]?.text_th ==
                "ตัวสำรอง"
                  ? item.reserved_no
                  : ""
              }}
            </template>
            <template v-slot:[`item.registration_status`]="{ item }">
              <span
                style="color: red"
                v-if="
                  item.registration_status === 'PENDING_PAYMENT' ||
                  item.registration_status === 'EXAM_UNAUTHORIZE'
                "
              >
                {{
                  studentRegistrationStatusMapping[item.registration_status]?.[
                    `text_${$i18n.locale}`
                  ] ?? "-"
                }}
              </span>
              <span
                v-else-if="
                  item.registration_status ===
                    'SUCCESSFUL_CONFIRMATION_DETAIL' ||
                  item.registration_status === 'SUCCESSFUL_CONFIRMATION'
                "
              >
                <v-icon left class="icon--primary" small
                  >mdi-check-circle</v-icon
                >{{
                  studentRegistrationStatusMapping[item.registration_status]?.[
                    `text_${$i18n.locale}`
                  ] ?? "-"
                }}
              </span>
              <span
                v-else-if="item.registration_status === 'SUCCESSFUL_ENROLLMENT'"
              >
                <v-icon left class="icon--green" small>mdi-shield-check</v-icon
                >{{
                  studentRegistrationStatusMapping[item.registration_status]?.[
                    `text_${$i18n.locale}`
                  ] ?? "-"
                }}
              </span>
              <span v-else>
                {{
                  studentRegistrationStatusMapping[item.registration_status]?.[
                    `text_${$i18n.locale}`
                  ] ?? "-"
                }}
              </span>
            </template>
            <template v-slot:[`item.updated_at`]="{ item }">
              {{ formatDateTime(item.updated_at) }}
            </template>
            <template v-slot:[`item.action`]="{ item }">
              <div class="custom-table-action">
                <v-icon
                  class="icon--disabled"
                  v-if="disabledDownload(item.registration_status)"
                  small
                  >mdi-download</v-icon
                ><v-icon v-else small @click="downloadStudentExcel(item)"
                  >mdi-download</v-icon
                >
                <router-link
                  class="icon--link"
                  :to="`/registration/calendar/${registrationFormId}/grade-plans/${registrationPlanId}/applicant/${item.id}`"
                  ><v-icon small>mdi-pencil</v-icon></router-link
                >
                <v-icon
                  class="icon--disabled"
                  v-if="disabledDelete(item.registration_status)"
                  small
                  >mdi-delete</v-icon
                ><v-icon v-else small @click="openDeleteConfirmationModal(item)"
                  >mdi-delete</v-icon
                >
              </div>
            </template>
            <template v-slot:no-data>
              <div
                class="custom-data-table-empty-data custom-data-table-empty-data-small"
              >
                <div>
                  <v-icon class="mb-2 icon--gray" large>mdi-file-find</v-icon>
                  <p>{{ $t("message.adminPage.notfound") }}</p>
                </div>
              </div>
            </template>
          </v-data-table>
          <VueHtml2pdf
            :show-layout="false"
            :float-layout="true"
            :enable-download="true"
            :preview-modal="false"
            :manual-pagination="true"
            :pdf-quality="2"
            pdf-content-width="100%"
            :html-to-pdf-options="pdfOption"
            ref="html2pdf"
          >
            <section slot="pdf-content">
              <ApplicationPart
                v-if="registrationFormDetail && organizationDetail"
                :registrationFormDetail="registrationFormDetail"
                :organizationDetail="organizationDetail"
                :studentDataList="studentDataList"
                :reportTitle="reportTitle"
                :programName="programName"
              />
            </section>
          </VueHtml2pdf>
        </v-sheet>
      </div>
    </div>
    <v-dialog v-model="isShowDeleteConfirmationModal" width="450">
      <div class="modal__content">
        <v-icon
          class="modal__icon modal__close-button"
          @click="closeDeleteConfirmationModal"
          >mdi-close</v-icon
        >
        <v-icon class="modal__icon modal__icon__red">mdi-alert-circle</v-icon>
        <p class="modal__title">
          {{ $t("message.registration_form.remove_list_of_applicants") }} ?
        </p>
        <p class="modal__description" v-if="selectedStudent">
          {{
            $t(
              "message.registration_form.remove_list_of_applicants_description",
              {
                name: `${selectedStudent.student_detail.prefix_id[`text_${$i18n.locale}`]}${selectedStudent.student_detail[`name_${$i18n.locale}`]} ${selectedStudent.student_detail[`surname_${$i18n.locale}`]}`,
              }
            )
          }}
        </p>
        <div class="modal__action">
          <v-btn
            color="primary"
            outlined
            rounded
            elevation="0"
            width="180"
            :loading="isSubmitting"
            @click="closeDeleteConfirmationModal"
          >
            {{ $t("message.common.cancel") }}
          </v-btn>
          <v-btn
            color="error"
            rounded
            elevation="0"
            width="180"
            :loading="isSubmitting"
            @click="deleteRegistrationForm"
          >
            {{ $t("message.common.confirm") }}
          </v-btn>
        </div>
      </div>
    </v-dialog>
  </BackofficeLayout>
</template>

<script>
import BackofficeLayout from "@/components/common/BackofficeLayout";
import * as services from "@/services";
import * as dateUtils from "@/utils/date";
import {
  PAGE_SIZE_OPTIONS,
  OPPOSITE_SORT,
  DEFAULT_PAGE_SIZE,
  REGISTRATION_STATUS_OPTION,
  RESULT_TYPE_OPTION,
  STUDENT_TYPE_MAPPING,
  STUDENT_RESULT_TYPE_MAPPING,
  STUDENT_REGISTRATION_STATUS_MAPPING,
} from "@/constants";
import router from "@/router";
import i18n from "@/i18n";
import VueHtml2pdf from "vue-html2pdf";
import PDFMerger from 'pdf-merger-js';
import ApplicationPart from "@/components/fileElement/ApplicantPart.vue";
import { genApplicationID, genApplicationData } from "@/utils/applicant";
import { getEnrollmentFormPDFBlob } from '@/utils/enrollmentFormPDF'
import { getFullGrade, getStudentYear } from "@/utils/studentYear";

const DEFAULT_SORT_KEY = "student_detail.national_id";
const DEFAULT_SORT_DIRECTION = "ASC";
export default {
  name: "RegistrationForm",
  components: {
    BackofficeLayout,
    VueHtml2pdf,
    ApplicationPart
},
  data() {
    return {
      student: [],
      summary: {
        total_student: 0,
        total_register: 0,
        total_successful_confirmation: 0,
        total_authorize: 0,
        total_enrollment: 0,
      },
      registrationFormId: null,
      registrationPlanId: null,
      registrationPlan: null,
      selectedStudent: null,
      registrationStatusOption: REGISTRATION_STATUS_OPTION,
      resultTypeOption: RESULT_TYPE_OPTION,
      studentResultTypeMapping: STUDENT_RESULT_TYPE_MAPPING,
      studentTypeMapping: STUDENT_TYPE_MAPPING,
      studentRegistrationStatusMapping: STUDENT_REGISTRATION_STATUS_MAPPING,
      keyword: "",
      selectedRegistrationStatus: "",
      selectedResultType: "",
      pages: 1,
      page: 1,
      pageSize: DEFAULT_PAGE_SIZE,
      total: 0,
      sort: DEFAULT_SORT_KEY,
      sortDirection: DEFAULT_SORT_DIRECTION,
      pageSizeOption: PAGE_SIZE_OPTIONS,
      isSubmitting: false,
      loading: 0,
      isShowDeleteConfirmationModal: false,
      downloadList: [
        { value: 1, text: `${this.$t("message.registration_form.list_of_exam_authorize")} (EXCEL)`},
        { value: 2, text: `${this.$t("message.registration_form.list_of_exam_authorize")} (PDF)`},
        { value: 3, text: `${this.$t("message.registration_form.list_of_qualified")} (EXCEL)`},
        { value: 4, text: `${this.$t("message.registration_form.list_of_qualified")} (PDF)`},
        { value: 5, text: this.$t("message.registration_form.list_of_applicant_ticket")},
      ],
      registrationFormDetail: {},
      organizationDetail: null,
      studentDataList: [],
      reportTitle: null,
      programName: null,
    };
  },
  mounted() {
    this.init();
    this.getRegistrationPlanById();
  },
  methods: {
    async downloadExcelCandidate() {
      try {
        this.loading++;
        const { id, plan_id } = this.$route.params;
        const { data } = await services.exportExcelCandidate(
          id,
          plan_id,
          `candidate_report_${id}_${plan_id}`,
        );
        const blob = new Blob([data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;",
        });
        const downloadUrl = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.target = "_blank";
        a.href = downloadUrl;
        a.download = `candidate_report_${id}_${plan_id}.xlsx`;
        document.body.appendChild(a);
        a.click();
      } catch (error) {
        console.log(error);
      } finally {
        this.loading--;
      }
    },
    async downloadStudentExcel(student_select) {
      try {
        this.loading++;
        const { data } = await services.exportExcelApplicant(student_select.id);
        const blob = new Blob([data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;",
        });
        const downloadUrl = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.target = "_blank";
        a.href = downloadUrl;
        a.download = `student_report_${student_select.id}.xlsx`;
        document.body.appendChild(a);
        a.click();
      } catch (error) {
        console.log(error);
      } finally {
        this.loading--;
      }
    },
    formatDateTime(date) {
      return dateUtils.formatDateTime(date, this.$i18n.locale);
    },
    async getRegistrationPlanById() {
      try {
        this.loading++;
        const { id, plan_id } = this.$route.params;
        const {
          data: { data },
        } = await services.getRegistrationCalendarPlanById(id, plan_id, {
          summary: true,
        });
        this.registrationPlan = data.registration_plan;
        this.summary = {
          total_student: data.registration_plan.total_students,
          total_register: data.summary.total_register,
          total_successful_confirmation:
            data.summary.total_successful_confirmation,
          total_authorize: data.summary.total_authorize,
          total_enrollment: data.summary.total_enrollment,
        };
      } catch (error) {
        console.log(error);
      } finally {
        this.loading--;
      }
    },
    async getRegistrationPlanStudentByPlanId() {
      try {
        this.loading++;
        const { plan_id } = this.$route.params;
        const query = this.prepareQuery();
        const {
          data: { data },
        } = await services.getRegistrationPlanStudentByPlanId(plan_id, query);
        this.student = data.student;
        this.pages = data.total_page;
        this.total = data.total;
      } catch (error) {
        console.log(error);
      } finally {
        this.loading--;
      }
    },
    search() {
      const { id, plan_id } = this.$route.params;
      const query = this.prepareQuery();
      router.push({
        path: `/registration/calendar/${id}/grade-plans/${plan_id}`,
        query: { ...query, keyword: this.keyword },
      });
    },
    changeRegistrationStatus(value) {
      const { id, plan_id } = this.$route.params;
      const query = this.prepareQuery();
      router.push({
        path: `/registration/calendar/${id}/grade-plans/${plan_id}`,
        query: { ...query, registration_status: value },
      });
    },
    changeResultType(value) {
      const { id, plan_id } = this.$route.params;
      const query = this.prepareQuery();
      router.push({
        path: `/registration/calendar/${id}/grade-plans/${plan_id}`,
        query: { ...query, result_type: value },
      });
    },
    init() {
      const { query, params } = this.$route;
      const keyword = query.keyword || "";
      const registrationStatus = query.registration_status || "";
      const resultType = query.result_type || "";
      const page = query.page ? parseInt(query.page) : 1;
      const pageSize = query.page_size
        ? parseInt(query.page_size)
        : DEFAULT_PAGE_SIZE;
      const sort = query.sort ? query.sort.split(":") : "";
      const sortKey = sort?.[0] ?? DEFAULT_SORT_KEY;
      const sortDirection = sort?.[1] ?? DEFAULT_SORT_DIRECTION;
      (this.registrationFormId = params.id),
        (this.registrationPlanId = params.plan_id),
        (this.keyword = keyword);
      this.selectedRegistrationStatus = registrationStatus;
      this.selectedResultType = resultType;
      this.page = page;
      this.pageSize = pageSize;
      this.sort = sortKey;
      this.sortDirection = sortDirection;
      this.getRegistrationPlanStudentByPlanId();
    },
    handleChangePage(newPage) {
      const query = this.prepareQuery();
      const path = this.$route.path;
      router.push({
        path,
        query: { ...query, page: newPage },
      });
    },
    handleChangePageSize(newPageSize) {
      const query = this.prepareQuery();
      const path = this.$route.path;
      router.push({
        path,
        query: { ...query, page_size: newPageSize },
      });
    },
    handleChangeSort(key) {
      let direction = "desc";
      if (key === this.sort) {
        direction = OPPOSITE_SORT[this.sortDirection] || "desc";
      }
      const sort = `${key}:${direction}`;
      const path = this.$route.path;
      const query = this.prepareQuery();
      router.push({
        path,
        query: { ...query, sort },
      });
    },
    prepareQuery() {
      return {
        keyword: this.keyword,
        registration_status: this.selectedRegistrationStatus,
        result_type: this.selectedResultType,
        page: this.page,
        page_size: this.pageSize,
        sort: `${this.sort}:${this.sortDirection}`,
      };
    },
    openDeleteConfirmationModal(data) {
      console.log(data);
      this.selectedStudent = data;
      this.isShowDeleteConfirmationModal = true;
    },
    closeDeleteConfirmationModal() {
      this.isShowDeleteConfirmationModal = false;
    },
    async deleteRegistrationForm() {
      try {
        this.loading++;
        await services.deleteStudent(this.selectedStudent.id);
      } catch (err) {
        console.log(err);
      } finally {
        this.init();
        this.closeDeleteConfirmationModal();
        this.loading--;
      }
    },
    disabledDelete(status) {
      if (!["EXAM_UNAUTHORIZE", "REJECTION", "NOT_QUALIFY"].includes(status))
        return true;
      return false;
    },
    disabledDownload(status) {
      if (
        [
          "REGISTER",
          "PENDING_PAYMENT",
          "SUCCESSFUL_PAYMENT",
          "EXAM_UNAUTHORIZE",
        ].includes(status)
      )
        return true;
      return false;
    },
    async getDataForDownload(value) {
    if (!this.organizationDetail) {
      const { data: { data: { organization }}} = await services.getOrganization();
      this.organizationDetail = organization;
    }

    const params = {
        status: value,
    }
    const { data: { data: { registration_form, students }}} = await services.getRegistrationDownloadByIdAndPlanId(this.registrationFormId, this.registrationPlanId, params);
    this.registrationFormDetail = registration_form
    this.studentDataList = students

    },
    async downloadExcel(value) { // value = 1,3
      try {
        this.loading++;
        const registerName = this.registrationPlan?.register_form_config?.register_name?.replaceAll(/[\s.]+/g, '_') || '';
        const programName = this.registrationPlan?.program[`program_name_${this.$i18n.locale}`]?.replaceAll(/[\s.]+/g, '_');
        const filename = value == 1 ? `exam_authorize_report_${registerName}_${programName}.xlsx` : `pass_authorize_report_${registerName}_${programName}.xlsx`;
        const params = {
          status: value,
        }

        const { data } = await services.exportExcelRegistrationResult(this.registrationFormId, this.registrationPlanId, params);
        const blob = new Blob([data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;",
        });
        const downloadUrl = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.target = "_blank";
        a.href = downloadUrl;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
      } catch (error) {
        console.log(error);
      } finally {
        this.loading--;
      }
    },
    async downloadPdf(value) { // value = 2,4,5
      try {
        this.loading++;
        await this.getDataForDownload(value);
        this.programName = this.registrationPlan.program[`program_name_${this.$i18n.locale}`];

        if (value == 5 ) {
          return await this.downloadApplicantTicketsPdf();
        }

        this.reportTitle = value == 2 ? `${this.$t('message.common.applicantReport.exam_authorize_title')}` :  `${this.$t('message.common.applicantReport.pass_authorize_title')}`
        this.$nextTick(() => {
          this.$refs.html2pdf.generatePdf();
        });
      } catch (error) {
        console.error('Error downloading PDF:', error)
        this.$toast.error(this.$t('message.common.downloadError'));
      } finally {
        this.loading--;
      }
    },
    async downloadApplicantTicketsPdf() {
      try {
        let merger = new PDFMerger();
        // await Promise.all(this.studentDataList.map(async (student) => {
        //   const pdfBlob = await this.getStudentData(student.id);
        //   await merger.add(pdfBlob);
        // }));

        const studentIds = this.studentDataList.map(student => student.id);
        const { students, studentParents } = await this.getStudentsWithParents(studentIds);
        for (const student of students) {
          const parentData = studentParents.filter((studentParent) => studentParent.student_parent_detail.id == student.id);
          const pdfBlob = await getEnrollmentFormPDFBlob(genApplicationData(student, parentData, true));
          await merger.add(pdfBlob);
        }

        const mergedPdfBlob = await merger.saveAsBlob();
        const registerName = this.registrationFormDetail?.register_name?.replaceAll(/[\s.]+/g, '_') || '';
        const programName = this.programName?.replaceAll(/[\s.]+/g, '_');
        const filename = `applicant_ticket_${registerName}_${programName}.pdf`
        const downloadUrl = URL.createObjectURL(mergedPdfBlob);
        //window.open(downloadUrl, '_blank');
        const a = document.createElement('a');
        a.target = '_blank';
        a.href = downloadUrl;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
      } catch (error) {
        console.error('Error downloading PDF:', error)
        this.$toast.error(this.$t('message.common.downloadError'));
      }
    },
    async getStudentsWithParents(studentIds) {
      try {
        const res = await services.getStudentsAndParentsWithQuery({
          ids: studentIds,
          query: {
            selects: {
              id: true,
              applicant_date: true,
              index_number: true,
              student_detail: {
                student_img: true,
                birthday: true,
                national_id: true,
                name_th: true,
                surname_th: true,
                name_en: true,
                surname_en: true,
                phone_number: true,
                prefix_id: {
                  text_th: true,
                  text_en: true,
                },
                nationality: {
                  name_th: true,
                  name_en: true,
                },
                ethnicity: {
                  name_th: true,
                  name_en: true,
                },
                religion: {
                  name_th: true,
                  name_en: true,
                },

              },
              student_other_detail: {
                former_school_last_student_year: {
                  value: true,
                },
                former_school_name: true,
                former_school_district: {
                  name_th: true,
                  name_en: true,
                },
                former_school_province: {
                  name_th: true,
                  name_en: true,
                },
              },
              student_address_detail: {
                national_address: true,
                national_moo: true,
                national_soi: true,
                national_road: true,
                national_subdistrict: {
                  name_th: true,
                  name_en: true,
                },
                national_district: {
                  name_th: true,
                  name_en: true,
                },
                national_province: {
                  name_th: true,
                  name_en: true,
                },
                national_postal_code: true,
              },
              student_parent_detail: {
                family_status: true,
                is_siblings_study_together: true,
                siblings_name: true,
                siblings_surname: true,
                siblings_grade: true,
                siblings_house: true,
              },
              register_plan: true,
              register_form: {
                grade_level: true,
                opening_date: true,
                closing_date: true,
                semester_year: true,
                exam_date: true,
                exam_start_time_phase1: true,
              }
            },
            relations: {
              student_address_detail: {
                national_province: true,
                national_district: true,
                national_subdistrict: true,
              },
              student_parent_detail: true,
              student_detail: {
                ethnicity: true,
                nationality: true,
                religion: true,
                prefix_id: true,
              },
              student_other_detail: {
                former_school_province: true,
                former_school_district: true,
              },
              register_plan: {
                program: true,
                student_year: true,
              },
              register_form: true,
            },
          }
        });

        const students = res?.data?.data?.students;
        const studentParents = res?.data?.data?.student_parents;

        for (const student of students) {
            let student_img = null;
            if (student?.student_detail?.student_img) {
                const imageData = await services.getImageBase64FromUrl(
                    student?.student_detail?.student_img
                );
                student_img = imageData.data.data.data;
                student['student_img'] = student_img;
                student['former_school_last_student_year_id'] = student?.student_other_detail?.former_school_last_student_year?.value;
            }
        }

        return { students, studentParents };
      } catch (error) {
          console.error('Error getting student info:', error)
      }
    },
  },
  computed: {
    pdfOption() {
      return {
        margin: 0,
        image: { type: "jpeg", quality: 0.98 },
        filename: "applicant_report.pdf",
        pagebreak: { mode: 'avoid-all', before: '.before', after: '.after', avoid: '.avoid' },
        html2canvas: { scale: 2, dpi: 900, letterRendering: true, useCORS: true },
        jsPDF: { unit: "mm", format: "a4", orientation: "portrait", compress: false },
      }
    },
    title() {
      if (!this.registrationPlan) return "";
      return `${
        this.registrationPlan.student_year[
          `student_year_name_${this.$i18n.locale}`
        ]
      } : ${
        this.registrationPlan.program[`program_name_${this.$i18n.locale}`]
      }`;
    },
    breadcrumb() {
      const breadcrumb = [
        {
          text: this.$t("message.registration_form.candidate_list"),
          link: "/registration/calendar",
        },
      ];
      if (this.registrationPlan) {
        breadcrumb.push(
          {
            text: `${this.$t("message.common.academic_year")} ${
              this.registrationPlan.register_form_config.semester_year
            }`,
            link: `/registration/calendar/${this.registrationPlan.register_form_config.id}`,
          },
          {
            text: `${
              this.registrationPlan.student_year[
                `student_year_name_${this.$i18n.locale}`
              ]
            } : ${
              this.registrationPlan.program[`program_name_${this.$i18n.locale}`]
            }`,
          }
        );
      }
      return breadcrumb;
    },
    headers() {
      return [
        {
          text: this.$t("message.common.id_card_number"),
          value: "national_id",
          sort: "student_detail.national_id",
          sortable: true,
          width: "18%",
        },
        {
          text: this.$t("message.common.full_name"),
          value: "name",
          sort: "student_detail.name_th",
          sortable: true,
          width: "20%",
        },
        {
          text: this.$t("message.registration_form.result"),
          value: "result_type",
          sort: "student.result_type",
          sortable: true,
          width: "15%",
        },
        {
          text: this.$t("message.common.type"),
          value: "type",
          sort: "student.result_type",
          sortable: true,
          width: "14%",
        },
        {
          text: this.$t("message.common.status"),
          value: "registration_status",
          sort: "student.registration_status",
          sortable: true,
          width: "15%",
        },
        {
          text: this.$t("message.common.last_edited"),
          value: "updated_at",
          sort: "student.updated_at",
          sortable: true,
          width: "13%",
        },
        { text: "", value: "action", width: "5%" },
      ];
    },
  },
  watch: {
    $route() {
      this.init();
    },
  },
};
</script>

<style scoped lang="scss">
.wrapper {
  padding: 0 24px 24px 24px;
}

.main {
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding-top: 24px;
  border-top: 1px solid #d7d6d8;
}

.statistic-panel {
  display: flex;
  gap: 14px;
}
.statistic {
  box-sizing: border-box;
  display: flex;
  gap: 14px;
  padding: 16px;
  flex: 1;
  border: 1px solid #fff;
  border-radius: 10px;
}

.statistic-icon {
  font-size: 36px;
}
.statistic-caption {
  font-family: "Prompt", sans-serif;
  font-size: 14px;
  margin-bottom: 0;
  .v-application[lang="en"] & {
    font-family: "inter", sans-serif !important;
  }
}

.statistic-value {
  font-family: "Prompt", sans-serif;
  font-size: 24px;
  margin-bottom: 0;
  .v-application[lang="en"] & {
    font-family: "inter", sans-serif !important;
  }
}

.statistic--blue {
  background-color: rgba(111, 162, 204, 0.3);
  border-color: #7fa2cc;
}

.statistic--blue > .statistic-icon {
  color: #7fa2cc;
}

.statistic--navy {
  background-color: rgba(37, 93, 152, 0.3);
  border-color: #255d98;
}

.statistic--navy > .statistic-icon {
  color: #255d98;
}

.statistic--brown {
  background-color: rgba(191, 153, 131, 0.3);
  border-color: #bf9983;
}

.statistic--brown > .statistic-icon {
  color: #bf9983;
}

.statistic--orange {
  background-color: rgba(241, 153, 109, 0.3);
  border-color: #f1996d;
}

.statistic--orange > .statistic-icon {
  color: #f1996d;
}

.statistic--gold {
  background-color: rgba(153, 91, 0, 0.3);
  border-color: #995b00;
}

.statistic--gold > .statistic-icon {
  color: #995b00;
}

.statistic--yellow {
  background-color: rgba(255, 193, 102, 0.3);
  border-color: #ffc166;
}

.statistic--yellow > .statistic-icon {
  color: #ffc166;
}

.advice-box {
  height: 150px;
  overflow-y: auto;
}

.advice-box > ul > li {
  color: var(--color-black);
}

.radius-10px {
  border-radius: 10px !important;
}

.custom_table_class thead th:first-child {
  border-radius: 6px 0 0 0;
}
.custom_table_class thead th:last-child {
  border-radius: 0 6px 0 0;
}
</style>
